<template>
    <div class="d-flex align-center gap-2" :data-testid="`${testIdPrefix}-header`">
        <h3 :data-testid="`${testIdPrefix}-header__title`">
            {{ title }}
        </h3>
        <div>
            <v-tooltip bottom content-class="tooltip-bottom">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                        v-bind="attrs" 
                        v-on="on" 
                        class="shadow-off mr-2" 
                        icon
                        @click="$emit('refresh')"
                        :data-testid="`${testIdPrefix}-header__refresh-button`">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </template>
                <span>Refresh</span>
            </v-tooltip>
        </div>
        <v-spacer></v-spacer>
    </div>
</template>

<script>
export default {
    name: 'ReportHeader',
    
    props: {
        title: {
            type: String,
            required: true,
        },
        testIdPrefix: {
            type: String,
            required: true,
        },
    },
};
</script>
